import { CLIENTS } from "../lib/constants";

export const Clients = () => {
  // Duplicate for seamless marquee
  const list = [...CLIENTS, ...CLIENTS];

  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="relative bg-[#FDFBF7] py-20 md:py-28 border-y border-[#0B2545]/10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-12 reveal">
        <div className="flex items-center gap-4 mb-6">
          <span className="gold-line" />
          <h2 className="font-sans text-[#0B2545] uppercase text-3xl md:text-4xl lg:text-5xl tracking-widest-2 font-semibold">
            Our Clientele
          </h2>
        </div>
        <p className="font-sans text-[#061426]/75 text-sm md:text-base max-w-2xl">
          Companies that have entrusted us with their cargo.
        </p>
      </div>

      <div
        data-testid="clients-marquee"
        className="relative w-full overflow-hidden"
        style={{
          maskImage:
            "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
          WebkitMaskImage:
            "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
        }}
      >
        <div className="flex gap-12 marquee-track w-max py-6">
          {list.map((c, i) => (
            <div
              key={`${c}-${i}`}
              className="flex items-center gap-6 px-8 py-5 border border-[#0B2545]/20 bg-white min-w-max"
            >
              <span className="block w-2 h-2 bg-[#C8A24A]" />
              <span className="font-serif text-[#0B2545] text-2xl md:text-3xl whitespace-nowrap font-semibold">
                {c}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
